import { Button, Modal } from 'antd';

interface ShowModalProps {
    show: boolean,
    message: string,
    isMassive: boolean,
    toggleShow: () => void,
    setResponse: React.Dispatch<React.SetStateAction<boolean>>,
    toggleParent?: () => void,
}

const ModalDelete = ({ show, toggleShow, message, isMassive, setResponse, toggleParent }: ShowModalProps) => {
    const handleClose = () => {
        setResponse(false);
        toggleShow();
        if (toggleParent != undefined) {
            toggleParent();
        }
    }
    const handleCloseWithResponse = () => {
        setResponse(true);
        toggleShow();
        if (toggleParent != undefined) {
            toggleParent();
        }
    }

    return (
        <Modal
            title={`Deletar ${isMassive ? "todos os Itens" : "Item"}`}
            open={show}
            width={400}
            onCancel={handleClose}
            footer={null}
            className='z-3'
        >
            <p>{message}</p>
            <div className='w-100 d-flex align-items-center justify-content-end mt-4'>
                <Button key="cancel" onClick={() => handleClose()} className='me-1'>
                    Não
                </Button>
                <Button type="primary" onClick={() => handleCloseWithResponse()} className='ms-1 btn-insert-excel delete-button'>
                    Sim
                </Button>
            </div>
        </Modal >
    )
}

export default ModalDelete;